import axios from '../axiosConfig'
import { getEnv } from '@utils/env'
import type { DashboardPeriod, DashboardPeriodParams } from './finance.api'
import type { DashboardMetricItemData } from '../../../types/dashboardMetrics.types'
import type { DashboardPieChartSlice } from '@components/pages/Dashboard/MetricCharts/DashboardPieChart.component'
import type { SchedulingChartConfig } from '../../../pages/Dashboard/SchedulingPerformanceDetail/schedulingPerformanceDetail.mockData'
import type { ExpenseCategoryBarConfig } from '../../../pages/Dashboard/ExpensesBreakdownDetail/expensesBreakdownDetail.mockData'
import type { SeatUtilizationDetailRow } from '../../../pages/Dashboard/SeatUtilizationDetail/seatUtilizationDetail.mockData'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_DASHBOARD')

interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

export type SeatUtilizationQueryParams = DashboardPeriodParams

export type SeatUtilizationResult = {
  period: DashboardPeriod
  periodStart: string
  periodEnd: string
  metrics: DashboardMetricItemData[]
  cardMetrics: DashboardMetricItemData[]
  donutSlices: DashboardPieChartSlice[]
  bySeatChart: SchedulingChartConfig
  expenseCategoryChart: ExpenseCategoryBarConfig
  rows: SeatUtilizationDetailRow[]
}

export const getSeatUtilization = (
  params: SeatUtilizationQueryParams,
  options?: { signal?: AbortSignal },
): Promise<SeatUtilizationResult> =>
  axios
    .get<
      ApiResponse<SeatUtilizationResult>
    >(`${BUSINESS_LAYER_API}/api/v1/dashboard/operations/seat-utilization`, { params, signal: options?.signal })
    .then((response) => response.data.data)

export const getSeatUtilizationOverview = (
  params: SeatUtilizationQueryParams,
  options?: { signal?: AbortSignal },
): Promise<SeatUtilizationResult> =>
  axios
    .get<
      ApiResponse<SeatUtilizationResult>
    >(`${BUSINESS_LAYER_API}/api/v1/dashboard/operations/seat-utilization/overview`, { params, signal: options?.signal })
    .then((response) => response.data.data)
